/**
 * @fileOverview Manages types of the particular action in the redux
 * @author Akhil Francis <akhil@trillium-technologies.com>
 * @example export const TYPE_NAME = 'VALUE'
 */
/**
 * @type {string}
 */
export const REQUEST_CANCEL = 'REQUEST_CANCEL';
export const LOGIN = 'LOGIN';
export const LOGIN_RES = 'LOGIN_RES';
export const LIST = 'LIST';
export const LIST_RES = 'LIST_RES';
export const GET_CODER = 'GET_CODERS';
export const GET_CODER_RES = 'GET_CODERS_RES';
export const SET_FILTER = 'SET_FILTER';
export const ICD_SEARCH = 'ICD_SEARCH';
export const ICD_SEARCH_RES = 'ICD_SEARCH_RES';
export const CPT_SEARCH = 'CPT_SEARCH';
export const CPT_EDIT = 'CPT_EDIT';
export const CPT_EDIT_RES = 'CPT_EDIT_RES';
export const CPT_SEARCH_RES = 'CPT_SEARCH_RES';
export const ICD_SAVE = 'ICD_SAVE';
export const ICD_SAVE_RES = 'ICD_SAVE_RES';
export const CPT_SAVE = 'CPT_SAVE';
export const CPT_SAVE_RES = 'CPT_SAVE_RES';
export const LOG_INFO_SAVE = 'LOG_INFO_SAVE';
export const LOG_INFO_SAVE_RES = 'LOG_INFO_SAVE_RES';
export const CODER_SAVE = 'CODER_SAVE';
export const CODER_SAVE_RES = 'CODER_SAVE_RES';
export const LOGIN_INFO = 'LOGIN_INFO';
export const LOGIN_INFO_RES = 'LOGIN_INFO_RES';
export const FILE_UPLOAD = 'FILE_UPLOAD';
export const FILE_UPLOAD_RES = 'FILE_UPLOAD_RES';
export const DOWNLOAD = 'DOWNLOAD';
export const DOWNLOAD_RES = 'DOWNLOAD_RES';
export const LOGLIST = 'LOGLIST';
export const LOGLIST_RES = 'LOGLIST_RES';
export const BULK_UPDATE = 'BULK_UPDATE';
export const BULK_UPDATE_RES = 'BULK_UPDATE_RES';
export const ROW_UPDATE = 'ROW_UPDATE';
export const ROW_UPDATE_RES = 'ROW_UPDATE_RES';
export const ICD_KEYWORD_SEARCH = 'ICD_KEYWORD_SEARCH';
export const ICD_KEYWORD_SEARCH_RES = 'ICD_KEYWORD_SEARCH_RES';
export const ICD_CODE_SEARCH = 'ICD_CODE_SEARCH';
export const ICD_CODE_SEARCH_RES = 'ICD_CODE_SEARCH_RES';
export const CPT_DELETE = 'CPT_DELETE';
export const CPT_DELETE_RES = 'CPT_DELETE_RES';
export const ICD_CHILD = 'ICD_CHILD';
export const ICD_CHILD_RES = 'ICD_CHILD_RES';
export const PA_HISTORY = 'PA_HISTORY';
export const PA_HISTORY_RES = 'PA_HISTORY_RES';
export const SEARCH_PAYOR = 'SEARCH_PAYOR';
export const SEARCH_PAYOR_RES = 'SEARCH_PAYOR_RES';
export const PATIENT_SAVE = 'PATIENT_SAVE';
export const PATIENT_SAVE_RES = 'PATIENT_SAVE_RES';
export const POLICYHOLDER_SAVE = 'POLICYHOLDER_SAVE';
export const POLICYHOLDER_SAVE_RES = 'POLICYHOLDER_SAVE_RES';
export const POLICY_SAVE = 'POLICY_SAVE';
export const POLICY_SAVE_RES = 'POLICY_SAVE_RES';
export const GET_PATIENT = 'GET_PATIENT';
export const GET_PATIENT_RES = 'GET_PATIENT_RES';
export const GET_PROVIDER = 'GET_PROVIDER';
export const GET_PROVIDER_RES = 'GET_PROVIDER_RES';
export const GET_CLAIM_LIST = 'GET_CLAIM_LIST';
export const GET_CLAIM_LIST_RES = 'GET_CLAIM_LIST_RES';
export const CLAIM_DOWNLOAD = 'CLAIM_DOWNLOAD';
export const CLAIM_DOWNLOAD_RES = 'CLAIM_DOWNLOAD_RES';
export const GET_PROCEDURE = 'GET_PROCEDURE';
export const GET_PROCEDURE_RES = 'GET_PROCEDURE_RES';
export const GET_NOTES = 'GET_NOTES';
export const GET_NOTES_RES = 'GET_NOTES_RES';
export const GET_APPT_NOTES = 'GET_APPT_NOTES';
export const GET_APPT_NOTES_RES = 'GET_APPT_NOTES_RES';
export const GET_CODER_FILES_LIST = 'GET_FILES_LIST';
export const GET_CODER_FILES_LIST_RES = 'GET_FILES_LIST_RES';
export const GET_ELIGIBILITY_FILES_LIST = 'GET_FILES_LIST';
export const GET_ELIGIBILITY_FILES_LIST_RES = 'GET_FILES_LIST_RES';
export const GET_PRIORAUTH_FILES_LIST = 'GET_FILES_LIST';
export const GET_PRIORAUTH_FILES_LIST_RES = 'GET_FILES_LIST_RES';
export const GET_PAYMENT_SUMMARY = 'GET_PAYMENT_SUMMARY';
export const GET_PAYMENT_SUMMARY_RES = 'GET_PAYMENT_SUMMARY_RES';
export const PROVIDER_SAVE = 'PROVIDER_SAVE';
export const PROVIDER_SAVE_RES = 'PROVIDER_SAVE_RES';
export const MAPPING_LIST = 'MAPPING_LIST';
export const MAPPING_LIST_RES = 'MAPPING_LIST_RES';
export const SAVE_MAPPING = 'SAVE_MAPPING';
export const SAVE_MAPPING_RES = 'SAVE_MAPPING_RES';
export const GET_CLAIM_SUMMARY = 'GET_CLAIM_SUMMARY';
export const GET_CLAIM_SUMMARY_RES = 'GET_CLAIM_SUMMARY_RES';
export const PRIORAUTH_LIST = 'PRIORAUTH_LIST';
export const PRIORAUTH_LIST_RES = 'PRIORAUTH_LIST_RES';
export const ARMGMT_LIST = 'ARMGMT_LIST';
export const ARMGMT_LIST_RES = 'ARMGMT_LIST_RES';
export const ELIGIBILITY_LIST = 'ELIGIBILITY_LIST';
export const ELIGIBILITY_LIST_RES = 'ELIGIBILITY_LIST_RES';
export const WRITEOFF = 'WRITEOFF';
export const WRITEOFF_RES = 'WRITEOFF_RES';
export const GET_LEDGER = 'GET_LEDGER';
export const GET_LEDGER_RES = 'GET_LEDGER_RES';
export const CLAIM_PREVIEW = 'CLAIM_PREVIEW';
export const CLAIM_PREVIEW_RES = 'CLAIM_PREVIEW_RES';
export const ICD_EDIT = 'ICD_EDIT';
export const ICD_EDIT_RES = 'ICD_EDIT_RES';
export const CLAIM_SUMMARY_SAVE = 'CLAIM_SUMMARY_SAVE';
export const CLAIM_SUMMARY_SAVE_RES = 'CLAIM_SUMMARY_SAVE_RES';
export const GET_ELIGIBILITY_NOTES = "GET_ELIGIBILITY_NOTES";
export const GET_ELIGIBILITY_NOTES_RES = "GET_ELIGIBILITY_NOTES_RES";
